import { Badge, type BadgeColor } from '@civilgrid/ui/components';

export const ASSET_TYPES = [
  'Cable',
  'Community Development District',
  'Electric',
  'Fiber',
  'Fiber-to-the-Premises',
  'Gas',
  'Geotech',
  'Moratoriums',
  'None',
  'Other',
  'Paving Projects',
  'Petroleum',
  'Pipeline',
  'Projects',
  'Railroad',
  'Recycled',
  'Sewer',
  'Steam',
  'Storm',
  'Telco',
  'Unknown',
  'Water',
] as const;

export type AssetType = (typeof ASSET_TYPES)[number];

const assetTypeColor: Record<AssetType, BadgeColor> = {
  Cable: 'red',
  'Community Development District': 'green',
  Electric: 'red',
  Fiber: 'orange',
  'Fiber-to-the-Premises': 'orange',
  Gas: 'yellow',
  Geotech: 'yellow',
  Moratoriums: 'purple',
  None: 'grey',
  Other: 'grey',
  'Paving Projects': 'purple',
  Petroleum: 'yellow',
  Pipeline: 'yellow',
  Projects: 'purple',
  Railroad: 'grey',
  Recycled: 'purple',
  Sewer: 'green',
  Steam: 'grey',
  Storm: 'green',
  Telco: 'orange',
  Unknown: 'grey',
  Water: 'blue',
};

interface Props {
  type?: string;
}

export default function ({ type }: Props) {
  if (!type) return null;
  const color = assetTypeColor[type as AssetType] || 'red';

  return (
    <div className="flex w-full items-center justify-start">
      <Badge color={color}>
        <span className="truncate">{type}</span>
      </Badge>
    </div>
  );
}
